"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useObservedElement", {
    enumerable: true,
    get: function() {
        return useObservedElement;
    }
});
const _useTabster = require("./useTabster");
const _tabster = require("tabster");
const _useTabsterAttributes = require("./useTabsterAttributes");
function useObservedElement(name) {
    const tabster = (0, _useTabster.useTabster)();
    if (tabster) {
        (0, _tabster.getObservedElement)(tabster);
    }
    return (0, _useTabsterAttributes.useTabsterAttributes)({
        observed: {
            names: Array.isArray(name) ? name : [
                name
            ]
        }
    });
}
